import React from "react";
import {
  BsFacebook,
  BsFillCaretRightFill,
  BsFillTelephoneFill,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
  BsYoutube,
} from "react-icons/bs";
import { FaLocationArrow } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
// import Button from "./button";
import { useQuery } from "@tanstack/react-query";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useLocation } from "react-router-dom";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
// import footerLogo from "../images/home_logo.png";

const Footer = () => {
  const { data, isLoading } = useQuery(["footer"], async () => {
    const response = await window.fetch(`${BASE_URL}/theme`);
    return await response.json();
  });
  const location = useLocation();

  if (isLoading) {
    return <p>Loading...</p>;
  }

  const {
    theme_contact,
    theme_footer,
    theme_logo,
    theme_socialmedia: { facebook, twitter, instra, youtube, linkedin },
  } = data?.theme;

  return (
    <footer className={`${location.pathname === "/" ? "mt-17" : ""}`}>
      <div className="bg-black">
        <div className="pt-7">
          <div
            style={{ border: "0.01rem solid rgba(155, 155, 153, 0.24)" }}
          ></div>
        </div>
        <div className="container-fluid">
          <div className="ms-13 me-13 mt-5 pb-9">
            <div className="row text-white">
              <div className="col-lg-3 mb-5 mb-lg-0">
                <div>
                  <LazyLoadImage
                    src={`${IMAGE_BASE_URL}/${theme_logo?.footer_logo}`}
                    effect="blur"
                    className="img-fluid"
                    loading="lazy"
                    alt="footer logo"
                  />
                </div>
                <p className="fs-18 lh-36 py-5">{theme_footer.description}</p>
                <p className="text-center text-lg-start">
                  <span className="social-margin">
                    <a href={facebook} target="_blank" rel="noreferrer">
                      <BsFacebook className="fs-24 cursor-pointer social-icon text-white" />
                    </a>
                  </span>
                  <span className="social-margin">
                    <a href={twitter} target="_blank" rel="noreferrer">
                      <BsTwitter className="fs-24 cursor-pointer social-icon text-white" />
                    </a>
                  </span>
                  <span className="social-margin">
                    <a href={instra} target="_blank" rel="noreferrer">
                      <BsInstagram className="fs-24 cursor-pointer social-icon text-white" />
                    </a>
                  </span>
                  <span className="social-margin">
                    <a href={youtube} target="_blank" rel="noreferrer">
                      <BsYoutube className="fs-24 cursor-pointer social-icon text-white" />
                    </a>
                  </span>
                  <span className="social-margin">
                    <a href={linkedin} target="_blank" rel="noreferrer">
                      <BsLinkedin className="fs-24 cursor-pointer social-icon text-white" />
                    </a>
                  </span>
                </p>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="ms-0 ms-md-5 ps-0 ps-md-5">
                  <p className="fs-22 gilroy-bold">Helpfull Links</p>
                  <div className="fs-20 py-5">
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/media-center"
                        className="text-decoration-none footer-text"
                      >
                        Media Center
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/afro-academy"
                        className="text-decoration-none footer-text"
                      >
                        Afro Academy
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/career"
                        className="text-decoration-none footer-text"
                      >
                        Career
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/build-your-career"
                        className="text-decoration-none footer-text"
                      >
                        Build Your Career
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/suppliers"
                        className="text-decoration-none footer-text"
                      >
                        Suppliers
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/investors"
                        className="text-decoration-none footer-text"
                      >
                        Investors
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <div className="ms-0">
                  <p className="fs-22 gilroy-bold">Industries</p>
                  <div className="fs-20 py-5">
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/industry/agriculture"
                        className="text-decoration-none footer-text"
                      >
                        Agriculture
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/industry/solar-alternative-energy"
                        className="text-decoration-none footer-text"
                      >
                        Solar & Alternative Energy
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/industry/smart-homes"
                        className="text-decoration-none footer-text"
                      >
                        Smart Homes
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/industry/software-apps"
                        className="text-decoration-none footer-text"
                      >
                        Software & Apps
                      </Link>
                    </p>
                    <p>
                      <span className="text-american-yellow me-3">
                        <BsFillCaretRightFill />
                      </span>
                      <Link
                        to="/industry/digital-marketing"
                        className="text-decoration-none footer-text"
                      >
                        Digital Marketing
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <p className="fs-24 gilroy-bold">Contact Info</p>
                <div className="fs-20 py-3 py-md-5">
                  <p>
                    <span className="text-american-yellow me-3">
                      <FaLocationArrow />
                    </span>
                    {theme_contact.address}
                    {/* <span className="footer-address-text">
                      District, 6th Octobar, Giza, Egypt
                    </span> */}
                  </p>
                  <p>
                    <span className="text-american-yellow me-3">
                      <BsFillTelephoneFill />
                    </span>
                    {theme_contact.phone}
                  </p>
                  <p className="mb-5 mb-lg-0">
                    <span className="text-american-yellow me-3">
                      <MdEmail />
                    </span>
                    {theme_contact.email}
                  </p>
                  {/* <p className="fs-24 gilroy-bold pt-3">Newsletter</p>
                  <div className="footer-input-margin">
                    <div className="d-flex justify-md-content-center">
                      <div className="mb-3 mb-md-0">
                        <input
                          type="email"
                          className="footer-input fs-16"
                          required
                          placeholder="Enter your email"
                        />
                      </div>
                      <div className="text-end">
                        <Button
                          text="submit"
                          cssName="text-uppercase fs-16 fw-700 bg-american-yellow footer-btn text-white"
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-american-yellow">
        <div className="container-fluid pt-3 pb-2">
          <div className="ms-13 me-13">
            <div className="d-none d-md-block d-lg-flex fs-20 text-center text-lg-start">
              <div className="flex-grow-1">
                <p className="">
                  Copy right @{new Date().getFullYear()}{" "}
                  <span className="text-white">AFRO Group</span> All Right
                  Reserved.
                </p>
              </div>
              <div className="">
                <Link
                  to="/terms-and-condition"
                  className="text-decoration-none text-dark"
                >
                  Terms and Conditions
                </Link>
              </div>
              <div className="ms-lg-5">
                <Link to="/sitemap" className="text-decoration-none text-dark">
                  Sitemap
                </Link>
              </div>
              <div className="ms-lg-5">
                <Link
                  to="/privacy-and-policy"
                  className="text-decoration-none text-dark"
                >
                  Privacy & Policy
                </Link>
              </div>
            </div>
            <div className="d-block d-md-none fs-20 text-center text-lg-start">
              <div className="">
                <Link
                  to="/terms-and-condition"
                  className="text-decoration-none text-dark"
                >
                  Terms and Conditions
                </Link>
              </div>
              <div className="d-flex justify-content-evenly">
                <div className="ms-lg-5">
                  <Link
                    to="/sitemap"
                    className="text-decoration-none text-dark"
                  >
                    Sitemap
                  </Link>
                </div>
                <div className="ms-lg-5">
                  <Link
                    to="/privacy-and-policy"
                    className="text-decoration-none text-dark"
                  >
                    Privacy & Policy
                  </Link>
                </div>
              </div>
              <div className="">
                <p className="fs-14">
                  Copyright @{new Date().getFullYear()}{" "}
                  <span className="text-white">AFRO Group</span> All Right
                  Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
